import React from 'react';

import { FaArrowRight } from 'react-icons/fa';

import { TitleBadge } from '@src/components/atoms/title-badge';
import { Heading11, Heading18, Heading7, Paragraph3 } from '@src/theme';
import { bemClassName } from '@src/utils/bem';

import { StyledAboutHowItWorksSection } from './styles';

const b = bemClassName('about-how-it-works-section');

const steps = [
  {
    number: '01',
    title: 'Create Your Profile',
    description:
      'Sign up and tell us about your goals, preferences, and current lifestyle. Our AI analyzes your unique needs.',
  },
  {
    number: '02',
    title: 'Get Your Personalized Plan',
    description:
      'Receive a customized nutrition and workout plan tailored specifically to your body, goals, and schedule.',
  },
  {
    number: '03',
    title: 'Track Your Progress',
    description: 'Log your meals, workouts, and habits. Watch your progress unfold with beautiful visual analytics.',
  },
  {
    number: '04',
    title: 'Achieve Your Goals',
    description: 'Stay motivated with insights, adjustments, and celebrate milestones as you transform your health.',
  },
];

const AboutHowItWorksSection = () => {
  return (
    <StyledAboutHowItWorksSection>
      <div className={b()}>
        <div className={b('inner')}>
          <div className={b('heading')}>
            <TitleBadge text="HOW IT WORKS" />
            <Heading7>Your Journey to Wellness</Heading7>
            <Paragraph3>Simple steps to transform your health and achieve lasting results.</Paragraph3>
          </div>
          <div className={b('steps')}>
            {steps.map((step, index) => (
              <React.Fragment key={index}>
                <div className={b('step')}>
                  <div className={b('step-number')}>
                    <Heading18>{step.number}</Heading18>
                  </div>
                  <div className={b('step-content')}>
                    <Heading11>{step.title}</Heading11>
                    <Paragraph3>{step.description}</Paragraph3>
                  </div>
                </div>
                {index < steps.length - 1 && (
                  <div className={b('arrow')}>
                    <FaArrowRight />
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </StyledAboutHowItWorksSection>
  );
};

export default AboutHowItWorksSection;
